import { motion } from "framer-motion";
import React from "react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import { fadeIn } from "../variants";

const About = ({ scrollToContact }) => {
  const [ref, inView] = useInView({
    threshold: 0.3,
  });

  return (
    <section className="section bg-pearl" id="about" ref={ref}>
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-center">
          {/* Content */}
          <motion.div
            variants={fadeIn("right", 0.3)}
            initial="hidden"
            whileInView="show"
            viewport={{ once: false, amount: 0.3 }}
            className="flex-1 space-y-8"
          >
            {/* Title */}
            <div>
              <span className="inline-block px-5 py-2 bg-white border border-stone/40 font-mono font-medium text-sm tracking-wider mb-4 shadow-elegant">
                À PROPOS
              </span>
              <h2 className="h2">
                Développeur
                <br />
                <span className="relative inline-block">
                  Fullstack
                  <span className="absolute -bottom-2 left-0 w-full h-3 bg-gradient-to-r from-navy/40 to-sage/40 -z-10 blur-sm" />
                </span>
              </h2>
              <p className="text-xl font-primary font-medium bg-gradient-to-r from-gold via-terracotta to-gold-rose bg-clip-text text-transparent mt-4">
                36 ans • Paris 🇫🇷
              </p>
            </div>

            {/* Description */}
            <div className="space-y-4 text-lg">
              <p>
                Après <strong>15 années</strong> à évoluer dans le domaine
                commercial et entrepreneurial, j'ai souhaité donner une nouvelle
                dimension à ma carrière professionnelle en suivant une{" "}
                <strong>formation intensive en développement web</strong> et
                applications fullstack.
              </p>
              <p>
                Passionné par la Tech depuis toujours, mon parcours varié m'a
                permis d'acquérir une solide expertise dans deux domaines
                complémentaires, alliant <strong>compétences commerciales</strong>{" "}
                et <strong>techniques informatiques</strong>.
              </p>
              <p>
                Aujourd'hui, je suis à la recherche d'un{" "}
                <strong>stage de 6 mois</strong> pour continuer ma montée en
                compétences.
              </p>
            </div>

            {/* CTA */}
            <button className="btn-primary" onClick={scrollToContact}>
              Discutons de votre projet
            </button>
          </motion.div>

          {/* Stats Cards */}
          <motion.div
            variants={fadeIn("left", 0.5)}
            initial="hidden"
            whileInView="show"
            viewport={{ once: false, amount: 0.3 }}
            className="flex-1 grid grid-cols-1 gap-6"
          >
            {/* Stat Card 1 */}
            <div className="relative bg-white border border-stone/30 p-8 shadow-elegant hover:shadow-elegant-lg transition-all duration-300 group">
              <div className="absolute -top-4 -right-4 w-16 h-16 bg-gradient-to-br from-gold to-gold-rose border border-gold-rose/30 flex items-center justify-center shadow-gold-glow">
                <span className="text-2xl">💰</span>
              </div>
              <div className="text-5xl font-primary font-bold text-charcoal mb-2">
                {inView ? <CountUp start={0} end={4} duration={3} /> : "0"}
                <span className="bg-gradient-to-r from-gold to-gold-rose bg-clip-text text-transparent">M+</span>
              </div>
              <div className="text-sm font-primary font-medium tracking-wider uppercase text-charcoal/60">
                De C.A Rapporté
              </div>
            </div>

            {/* Stat Card 2 */}
            <div className="relative bg-white border border-stone/30 p-8 shadow-elegant hover:shadow-elegant-lg transition-all duration-300 group">
              <div className="absolute -top-4 -right-4 w-16 h-16 bg-gradient-to-br from-navy to-navy-dark border border-navy/30 flex items-center justify-center shadow-elegant">
                <span className="text-2xl">🚀</span>
              </div>
              <div className="text-5xl font-primary font-bold text-charcoal mb-2">
                {inView ? <CountUp start={0} end={15} duration={3} /> : "0"}
                <span className="text-navy"> ans</span>
              </div>
              <div className="text-sm font-primary font-medium tracking-wider uppercase text-charcoal/60">
                D'expérience Pro
              </div>
            </div>

            {/* Stat Card 3 */}
            <div className="relative bg-white border border-stone/30 p-8 shadow-elegant hover:shadow-elegant-lg transition-all duration-300 group">
              <div className="absolute -top-4 -right-4 w-16 h-16 bg-gradient-to-br from-sage to-sage-dark border border-sage/30 flex items-center justify-center shadow-elegant">
                <span className="text-2xl">⭐</span>
              </div>
              <div className="text-5xl font-primary font-bold text-charcoal mb-2">
                {inView ? <CountUp start={0} end={1000} duration={3} /> : "0"}
                <span className="text-sage-dark">+</span>
              </div>
              <div className="text-sm font-primary font-medium tracking-wider uppercase text-charcoal/60">
                Clients Satisfaits
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
